// Pure helpers for DmcModal. No React, no Redux, no hooks. Importable from
// plain JS tests; safe to call from anywhere.

export const parseLabel = (field) => (field?.label ? field.label : field?.name)

export const parseValue = (field) => (field?.value ? field.value : field?.id)

export const buildFilePayload = ({ dmcFile, poaFile, achFile, noticeFile, tpcFile }) => [
  { file: dmcFile?.[0] || null, type: 'document_type_dmc' },
  { file: poaFile?.[0] || null, type: 'document_type_poa' },
  { file: null, type: 'document_type_cease_desist' }, // C&D removed from DMC QA; slot kept for payload position (file3). Backend path dormant.
  { file: achFile?.[0] || null, type: 'document_type_dmc_ach_revocation' },
  { file: noticeFile?.[0] || null, type: 'document_type_dmc_drop_notice' },
  { file: tpcFile?.[0] || null, type: 'document_type_tpc_communication_order' }, // file6 — TPC Communication Order (replaces loan-level C&D in this QA)
]

export const buildDmcRequestBody = (formData, ctx) => {
  const {
    isCreating,
    isActive,
    isUpdatingBA,
    haveBankDetails,
    fullBankAccountNumberForSubmit,
    loanDmcData,
  } = ctx

  const commonFields = {
    dmc_status_dropdown_option_id: formData.dmc_status_dropdown_option_id,
    have_bank_details: haveBankDetails,
    poa_is_active: formData.poa_is_active,
    ach_revoke_is_active: formData.ach_revoke_is_active,
    drop_notice_is_active: formData.drop_notice_is_active,
    email_address: formData.email_address,
    phone_number: formData.phone_number,
    address: formData.address,
    address2: formData.address2,
    city: formData.city,
    state_dropdown_option_id: formData.state_dropdown_option_id,
    zip_code_id: formData.zip_code_id,
    bank_account_number:
      isCreating || isUpdatingBA ? formData.bank_account_number : fullBankAccountNumberForSubmit,
    bank_account_holder_name: formData.bank_account_holder_name,
    bank_routing_number_id: formData.bank_routing_number_id?.value,
    dmc_id: formData.dmc_id,
    dmc_name: formData.dmc_name,
  }

  if (isCreating) {
    return { ...commonFields, is_creating: true, is_active: true }
  }

  return {
    ...commonFields,
    is_creating: false,
    loan_dmc_id: loanDmcData?.loan_dmc?.id,
    is_active: isActive,
  }
}

// Collapse the /customer/{id}/loan_dmc response into one structured object
// the hook can splat across its setters. Mirrors the cascade currently inlined
// in `getCustomerDmc` (DmcModal.jsx lines 124–181).
export const parseLoanDmcResponse = (response) => {
  const data = response?.data?.data
  const loanDmc = data?.loan_dmc

  return {
    loanDmcData: data,
    isCreating: !loanDmc?.id,
    isActive: !!loanDmc?.is_active,
    selectedDmcOption: loanDmc?.dmc
      ? { id: loanDmc.dmc_id, name: loanDmc.dmc.name }
      : null,
    hasBusinessLicense: loanDmc?.dmc?.has_business_license ?? null,
    isPoaActive: !!loanDmc?.power_of_attorney_customer_id,
    achDocId: data?.documents?.document_type_dmc_ach_revocation?.id || false,
    achDocTypeId: data?.documents?.document_type_dmc_ach_revocation?.document_type_dropdown_option_id,
    noticeDocId: data?.documents?.document_type_dmc_drop_notice?.id || false,
    noticeDocTypeId: data?.documents?.document_type_dmc_drop_notice?.document_type_dropdown_option_id,
    tpcDocId: data?.documents?.document_type_tpc_communication_order?.id || false,
    tpcDocTypeId: data?.documents?.document_type_tpc_communication_order?.document_type_dropdown_option_id,
    haveBankDetails: !!data?.bank_account?.id,
    bankName: data?.bank_account?.bank_name,
    fullBankAccountNumberForSubmit: data?.bank_account?.bankAccountNumberUncrypted,
    dmcDocId: data?.documents?.document_type_dmc?.id,
    dmcDocTypeId: data?.documents?.document_type_dmc?.document_type_dropdown_option_id,
    poaDocId: loanDmc?.power_of_attorney_customer?.document?.id,
    poaDocTypeId: loanDmc?.power_of_attorney_customer?.document?.document_type_dropdown_option_id,
  }
}
